<template>
  <div class="def-insert-tilda" v-html="getHtmlStringWithoutScripts"></div>
</template>

<script>
export default {
  name: 'DefInsertTilda',
  props: ['result'],
  computed: {
    getHtmlStringWithoutScripts() {
      if (typeof this.result !== 'string') return '';

      return this.result.replace(/<script[^>]*>([\S\s]*?)<\/script>/g, '');
    },
  },
  mounted() {
    if (typeof this.result !== 'string') {
      console.warn('[DefInsertTilda] invalid "result" prop: expected string, got', this.result);
      return;
    }

    try {
      this.executeScriptsFromHtml(this.result);
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    executeScriptsFromHtml(htmlString) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // Витягуємо всі <script>
      const scripts = tempDiv.querySelectorAll('script[src]');
      const scriptsInline = tempDiv.querySelectorAll('script:not([src])');

      const runInlineScripts = () => {
        scriptsInline.forEach((script) => {
          const newScript = document.createElement('script');

          // Якщо inline — вставляємо текст
          newScript.text = script.textContent;

          document.body.appendChild(newScript);
        });
      };

      // внешних скриптов нет — выполняем инлайновые сразу
      if (!scripts.length) {
        runInlineScripts();
        return;
      }

      scripts.forEach((script, key) => {
        const newScript = document.createElement('script');

        if (script.src) {
          // Якщо є src — підключаємо з URL
          newScript.src = script.src;
          newScript.async = false; // Зберігаємо порядок
          newScript.defer = true; // Зберігаємо порядок

          const isLast = key === scripts.length - 1;

          // після завантаження останього зовнішнього скрипта виконуємо інлайнові скрипти.
          if (isLast) {
            newScript.onload = () => {
              runInlineScripts();
            };
          }

          // скрипт не завантажився — логуємо, інлайнові все одно виконуємо
          newScript.onerror = () => {
            console.error('[DefInsertTilda] failed to load script', script.src);
            if (isLast) runInlineScripts();
          };
        }

        document.body.appendChild(newScript);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.def-insert-tilda {
  :deep(img) {
    display: inline-block;
  }
}
</style>
